"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_dom_1 = require("react-dom");
var useWindowLoaded_1 = require("../useWindowLoaded");
var Modal_1 = require("./Modal");
var ModalContext_1 = __importDefault(require("./ModalContext"));
var Page_1 = require("./Page");
var useModal = function (props) {
    var _a = (0, react_1.useState)((props === null || props === void 0 ? void 0 : props.isInitialOpen) || false), isOpen = _a[0], setIsOpen = _a[1];
    var _b = (0, react_1.useState)(''), initialDocumentOverFlow = _b[0], setInitialDocumentOverFlow = _b[1];
    var prevFocusedElement = (0, react_1.useRef)(null);
    var modalHistoryRef = (0, react_1.useRef)([]); // this provides the modal history in order
    var pageSetRef = (0, react_1.useRef)(new Set()); // this provides constant time look-up for "seen" pages
    var isClient = (0, useWindowLoaded_1.useWindowLoaded)();
    var _c = (0, react_1.useState)({
        currentId: props === null || props === void 0 ? void 0 : props.initialPage,
        animatingId: '',
        direction: 0
    }), animationState = _c[0], setAnimationState = _c[1];
    var _d = (0, react_1.useState)('full'), mobileStyle = _d[0], setMobileStyle = _d[1];
    var goForwardTo = function (pageId) {
        var currentId = animationState.currentId;
        modalHistoryRef.current.push(currentId);
        pageSetRef.current.add(currentId);
        setAnimationState({
            currentId: pageId,
            animatingId: pageId,
            direction: 1
        });
    };
    var contextValue = {
        modalHistoryRef: modalHistoryRef,
        pageSetRef: pageSetRef,
        animationState: animationState,
        setAnimationState: setAnimationState,
        mobileStyle: mobileStyle,
        setMobileStyle: setMobileStyle
    };
    var resetModal = function () {
        setAnimationState({
            currentId: props === null || props === void 0 ? void 0 : props.initialPage,
            animatingId: '',
            direction: 0
        });
        modalHistoryRef.current = [];
        pageSetRef.current = new Set();
    };
    (0, react_1.useEffect)(function () {
        setInitialDocumentOverFlow(document.body.style.overflow);
    }, []);
    var closeModal = (0, react_1.useCallback)(function () {
        if (prevFocusedElement.current) {
            prevFocusedElement.current.focus();
        }
        document.body.style.overflow = initialDocumentOverFlow;
        setIsOpen(false);
        resetModal();
    }, []);
    var openModal = (0, react_1.useCallback)(function () {
        prevFocusedElement.current = document.activeElement;
        document.body.style.overflow = 'hidden';
        setIsOpen(true);
    }, []);
    var Modal = (0, react_1.forwardRef)(function (_a, ref) {
        var children = _a.children, rest = __rest(_a, ["children"]);
        return isClient && isOpen
            ? (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(ModalContext_1.default.Provider, __assign({ value: contextValue }, { children: (0, jsx_runtime_1.jsx)(Modal_1.ModalComponent, __assign({ ref: ref }, rest, { isMultiPage: (props === null || props === void 0 ? void 0 : props.initialPage) !== undefined, closeModal: closeModal }, { children: children })) })), (props === null || props === void 0 ? void 0 : props.rootNode) || document.body)
            : null;
    });
    return { Modal: Modal, closeModal: closeModal, isOpen: isOpen, openModal: openModal, goForwardTo: goForwardTo, Page: Page_1.Page };
};
exports.useModal = useModal;
